import commonUtil from "@/utils/commonUtil";

const imgUtil = {
  // 默认图片路径
  defaultImgPath: require("@/assets/images/jdError.png"),
  misBaseUrl: "https://www.jbchip.com/goodsImg",
  esBaseUrl: "https://www.jbchip.com/download",

  // 根据图片路径获取完整图片URL地址
  getImgUrls(item) {
    // 不存在图片则展示默认图片
    if (commonUtil.isNull(item)) {
      return [this.defaultImgPath];
    }
    // 优先取 misImgs
    const misImgs = item['goods_imgs'];
    if (!commonUtil.isNull(misImgs)) {
      return misImgs.map(url => this.misBaseUrl + url);
    }

    // 其次取 esImgs
    const esImgs = item['ty_imgs'];
    if (!commonUtil.isNull(esImgs)) {
      return esImgs.map(img => this.esBaseUrl + (img?.img_local_url || ''));
    }

    // 都没有，返回默认图（可选，根据业务决定是否加）
    return [this.defaultImgPath];
  },



  // 从多张图片中取一张图片展示
  getSingleImgUrl(item) {
    return this.getImgUrls(item)[0];
  },

  getImgNum(item) {
    // 不存在图片则展示默认图片
    if (commonUtil.isNull(item)) {
      return 0;
    }
    // 优先取 misImgs
    const misImgs = item['goods_imgs'];
    if (!commonUtil.isNull(misImgs)) {
      return misImgs.length;
    }

    // 其次取 esImgs
    const esImgs = item['ty_imgs'];
    if (!commonUtil.isNull(esImgs)) {
      return esImgs.length;
    }

    // 都没有，返回默认图（可选，根据业务决定是否加）
    return 0;
  },
};

export default imgUtil;
